var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full px-3 flex items-center cursor-pointer border-0 border-r border-solid border-gray-700",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"ds-text-2xl text-white",class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }